import React, { Component } from 'react';
import { FieldArray } from 'redux-form';
import { createStyles, withStyles } from '@material-ui/core/styles';

import PropertyGroups from '../../../../Common/Partials/PropertyGroups/PropertyGroups';
import FetchData from '../../../../Framework/Fetch';

const styles = createStyles({
  bidders: {
    minWidth: 180
  },
  bidfloor: {
    display: 'inline-block'
  },
  fields: {
    width: '80%'
  },
  identifier: {
    width: '100%'
  }
});

type Props = {
  record: any
};

type StateProps = {
  propertyGroupOptions: string[]
};

class PropertyGroupsTab extends Component<Props, StateProps> {
  state = { propertyGroupOptions: [] };

  componentDidMount() {
    FetchData('/helpers/lookup_property_groups', { field: 'name', order: 'ASC', visibility: 'campaigns' })
      .then(propertyGroups => {
        this.setState({ propertyGroupOptions: propertyGroups });
      });
  }

  handlePropertyGroupsRemove = (event, index) => {
    this.props.record.property_groups.splice(index, 1);
  }

  render() {
    const propertyGroupRecords = this.props.record.property_groups ? this.props.record.property_groups : [];

    return (
      <div style={{ paddingTop: 20 }}>
        <div>
          <FieldArray propertyGroupOptions={this.state.propertyGroupOptions} propertyGroupRecords={propertyGroupRecords} handlePropertyGroupsRemove={this.handlePropertyGroupsRemove} addItemLabel="Add Property Group" component={PropertyGroups} mainLabel="Property Groups" name="property_groups" record={this.props.record} /><br />
        </div>
      </div>
    );
  }
};

export default withStyles(styles)(PropertyGroupsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/PropertyGroupsTab.tsx